import Callout from "../../components/Callout/Callout";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";

export default function Smjernice() {
    return (
        <div>
            <Header />
            <Hero
                title="Smjernice za ostavljanje iskustava"
                subtitle="Osiguraj da tvoje iskustvo bude objavljeno"
            />
            <article className="mt-16 mb-32 max-w-screen-lg mx-auto px-6 lg:px-0 prose prose-md space-y-5 leading-8">
                <Callout>
                    Kandidati koji traže posao oslanjaju se na Dzobs.com
                    iskustva kako bi pronašli poslove i kompanije koje vole.
                    Slijedite ove smjernice kako biste osigurali da svi mogu
                    imati koristi od korisnih, uravnoteženih i autentičnih
                    iskustava o radu.
                </Callout>

                <ol className="list-decimal list-inside space-y-5">
                    <li>
                        Vaše iskustvo treba da bude istinito i da predstavlja
                        vaše lično mišljenje i utisak u vezi sa vašim trenutnim
                        ili bivšim poslodavcem. Ne zauzimamo stranu kada su u
                        pitanju činjenični sporovi, pa očekujemo da stanete iza
                        svojih izjava izraženih u vašem sadržaju.
                    </li>
                    <li>
                        Podstičemo vas da razmislite o poslu iz nekoliko
                        perspektiva i uključite i za i protiv kako biste pružili
                        uravnotežen pregled. Iako nije potrebno, vjerujemo da
                        uravnotežena iskustva imaju veću informativnu vrijednost
                        za druge tražitelje posla.
                    </li>
                    <li>
                        Svjesni smo da vaša iskustva mogu biti emocionalno
                        teška, ali ne odobravamo kritike koje uključuju
                        vulgarnosti, prijetnje nasiljem ili diskriminatorni
                        jezik usmjeren na pojedinca ili grupu. Možemo dozvoliti
                        iskustva koja spominju rasu, vjeru, nacionalnost, spol,
                        seksualnu orijentaciju i slično ako vjerujemo da se
                        komentar koristi za stvarno opisivanje situacije na
                        radnom mjestu. Dozvoljene su opšte rasprave o nedoličnom
                        ponašanju na radnom mjestu, uključujući većinu diskusija
                        o nezakonitim aktivnostima, diskriminaciji i seksualnom
                        uznemiravanju.
                    </li>
                    <li>
                        Ne prihvatamo iskustva koja otkrivaju povjerljive,
                        nejavne interne informacije kompanije. Smatramo da ovo
                        uključuje: izvorni kod, liste kupaca, proizvodne
                        tehnike, aktivnosti istraživanja i razvoja, budžete,
                        detaljne finansijske rezultate i tehničko znanje.
                    </li>
                    <li>
                        Da bismo zaštitili privatnost, ne dozvoljavamo vam da se
                        identifikujete niti uključite bilo kakve kontakt
                        informacije (o sebi ili drugima) u svoje objave.
                        Dodatno, izbjegavajte titule i druge naizgled generičke
                        informacije koje bi nekom omogućile da lako identifikuju
                        vas ili druge. Primjera radi, ako ste jedini Lead Web
                        Developer u firmi, za titulu odaberite samo Developer.
                    </li>
                    <li>
                        Dzobs.com se bavi dijeljenjem informacija koje pomažu
                        cijeloj zajednici. Odbijamo iskustva koja se ne odnose
                        na poslodavca, samo su recenzija proizvoda ili usluge
                        ili na drugi način nisu relevantne za razumijevanje
                        kulture radnog mjesta. Odbacićemo svaki sadržaj koji je
                        namijenjen kao reklama ili koji sadrži linkove.
                    </li>
                    <li>
                        Sva iskustva treba da budu originalna, bez značajnog
                        citiranog materijala iz drugih izvora, uključujući (ali
                        ne ograničavajući se na) web stranice, e-mail
                        korespondenciju, iskustva drugih itd.
                    </li>
                    <li>
                        Vaše pisanje ne mora biti savršeno, ali moramo biti u
                        stanju da ga razumijemo. Odbijamo recenzije zbog
                        pretjeranog pisanja velikih i malih slova ili
                        riječi/karaktera. I zapamtite, vaša će recenzija biti
                        vjerodostojnija ako koristite dobru gramatiku, pravopis
                        i interpunkciju.
                    </li>
                </ol>
            </article>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
